import { useQuery } from '@tanstack/react-query';
import getPriorToDefinitions from 'src/services/encompass/getPriorToDefinitions';

export const usePriorToDefinitionsQuery = (typeId: string, enabled = true) => {
  return useQuery({
    queryKey: [
      '/encompass/condition-types/prior-to-definitions',
      typeId,
    ] as const,
    queryFn: getPriorToDefinitions,
    enabled: enabled && typeId.length > 0,
  });
};
